import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "lx_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

export const apiError = (e) => {
  const d = e.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(" ");
  return e.message || "Something went wrong.";
};

export const login = (email, password) =>
  axios.post(`${API}/api/auth/login`, { email, password }).then((r) => r.data);
export const me = () => axios.get(`${API}/api/auth/me`, { headers: authHeaders() }).then((r) => r.data);

export const fetchPosts = (category) =>
  axios.get(`${API}/api/blog/posts`, { params: category ? { category } : {} }).then((r) => r.data.posts);
export const fetchCategories = () =>
  axios.get(`${API}/api/blog/categories`).then((r) => r.data.categories);
export const fetchPost = (slug) => axios.get(`${API}/api/blog/posts/${slug}`).then((r) => r.data);

export const adminListPosts = (status) =>
  axios.get(`${API}/api/admin/posts`, { params: status ? { status } : {}, headers: authHeaders() }).then((r) => r.data.posts);
export const adminSavePost = (post) =>
  post.id
    ? axios.put(`${API}/api/admin/posts/${post.id}`, post, { headers: authHeaders() }).then((r) => r.data)
    : axios.post(`${API}/api/admin/posts`, post, { headers: authHeaders() }).then((r) => r.data);
export const adminSetStatus = (id, action) =>
  axios.post(`${API}/api/admin/posts/${id}/status`, { action }, { headers: authHeaders() }).then((r) => r.data);
export const adminDeletePost = (id) =>
  axios.delete(`${API}/api/admin/posts/${id}`, { headers: authHeaders() }).then((r) => r.data);
export const adminGenerateDraft = (topic) =>
  axios.post(`${API}/api/admin/generate-draft`, { topic: topic || "" }, { headers: authHeaders() }).then((r) => r.data);
export const adminGenerateBatch = (count) =>
  axios.post(`${API}/api/admin/generate-batch`, { count }, { headers: authHeaders() }).then((r) => r.data);
export const adminBatchStatus = () =>
  axios.get(`${API}/api/admin/generate-batch/status`, { headers: authHeaders() }).then((r) => r.data);
export const adminListMessages = (type, status) =>
  axios.get(`${API}/api/admin/messages`, { params: { type, status: status || "" }, headers: authHeaders() }).then((r) => r.data);
export const adminSetMessageStatus = (type, id, status) =>
  axios.post(`${API}/api/admin/messages/${type}/${id}/status`, { status }, { headers: authHeaders() }).then((r) => r.data);
export const adminImprovePost = (id) =>
  axios.post(`${API}/api/admin/posts/${id}/improve`, {}, { headers: authHeaders() }).then((r) => r.data);
